<template>

  <div class="container flex" style="margin-bottom: 20px;">
    <left></left>
    <div class="live flex1" style="margin-left: 20px;">
    	<div class="title">
    		考试详情
    	</div>
    	<div class="bg padding-15">
    		<div class="gray">
    			<div class="titles font18" style="font-weight: bold;">
    				{{examObj.title}}
    			</div>
    			<!-- <div class="smallTitle margin-t-10">
    				初级经济法基础原题真题答案解析回顾
    			</div> -->
    			<div class="flex" style="justify-content: center;align-items: center;margin-top: 60px;">
    				<span class="font14">答题时间：</span>
    				<span style="font-size: 30px;color: #ef0202;">{{examObj.minutes}}分钟</span>
    				<span class="font14" style="margin-left: 200px;">总分：</span>
    				<span style="font-size: 30px;color: #ef0202;">{{examObj.totalScore}}分</span>
    			</div>
    			<div class="" style="color: #666666;margin-top: 35px;">
    				共{{examObj.totalQuestionsCount}}道   已有{{examObj.peopleCount}}人作答
    			</div>
    			<div class="btnwrap">
    				<span class="btn" @click="handleToEaxm">开始考试</span>
    			</div>
    		</div>
    		<div class="des">
    			<!-- <div class="font18" style="margin: 10px 0;">
    				题型介绍
    			</div> -->

    			<!-- <div class="font14" style="color: #999;">
    				<span style="color: #4fa7ff;">单项选择题：</span>本类题共20小题,每小题1.5分,共30分。每小题备选答案中,只有一个符合题忘的正确答案。销选、不选均不得分。
    			</div>

    			<div class="font14 margin-t-15" style="color: #999;">
    				<span style="color: #4fa7ff;">多项选择题：</span>本类题共10小题,每小题2分,共20分。每小题备选答案中,有两个或两个以上符合题意的正确答案。请至少选择两个答案,全部选对得满分,多选、少选、错选、不选均不得分判断题本类题共10小题,每题1分,共10分。请判断每小题的表述是否正确,每小题答题正确得1分,错答、不答均不得分,也不扣分。

    			</div>
    			<div class="font14 margin-t-15" style="color: #999;">
    				<span style="color: #4fa7ff;">计算分析题：</span>本类题共3小题,共15分。凡要求计算的,可不列出计算过程;计算结果出现两位以上小数的,均四舎五入保留小数点后两位小数,百分比指标保留百分号前两位小数。凡要求解释、分析、说明理由的,必须给出相应的文字削述。

    			</div>
    			<div class="font14 margin-t-15" style="color: #999;">
    				<span style="color: #4fa7ff;">综合题：</span>本类题共2小题,共25分。凡要求计算的,可不列出计算过程;计算结果出现两位以上小数的,均四舎五入保留小数点后两位小数,百分比指标保留百分号前两位小数。凡要求解释、分析、说明理由的,必须给出相应的文字阐述。

    			</div> -->
          <div v-html="examObj.content"></div>
    			</div>
    			<div class="line">

    			</div>
    		<div class="">
    			<div class="font18" style="margin: 0 0 15px 0;">
    				考前必读
    			</div>
    			<div class="font14" style="color: #999;">
    				1.如果你已经准备好了,就点击“开始考试”按钮开始考试
    			</div>
    			<div class="font14 margin-t-15" style="color: #999;">
    				2.选项前的单选框()表示该题只能选择一个答案
    			</div>
    			<div class="font14 margin-t-15" style="color: #999;">
    				3.选项前的复选框0表示该题可以选择一个或多个答案
    			</div>
    			<div class="font14 margin-t-15" style="color: #999;">
    				4.当完成考试交卷后,主观题请根据参考答案自己评分
    			</div>


    		</div>
    	</div>
    </div>

  </div>

</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          questionsStatus:this.$route.query.questionsStatus,
          testQuestionsId:this.$route.query.testQuestionsId,
          storageTag:0,
          examObj:{}
      }
    },
    methods:{
      getData(){
        let data={
          testQuestionsId:this.testQuestionsId
        };
        this.$axios.get(this.$common.testPaper_testPaperDetail,{params:data}).then((res)=>{
              if(res.data.code==1){

                  this.examObj=res.data.data;
                  this.storageTag=this.examObj.storageTag
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleToEaxm(){
        this.$router.push('onlinetest?questionsStatus='+this.questionsStatus+'&testQuestionsId='+this.testQuestionsId+'&title='+this.examObj.title+'&minutes='+this.examObj.minutes+'&storageTag='+this.storageTag+'&oneCategoryId='+this.examObj.oneCategoryId)
      }
    },
    created(){
      this.getData();
    }
  }
</script>

<style scoped="">
  .gray {
  	background-color: #f0f7ff;
  	text-align: center;
  	padding: 30px 0;
  }
  .btn {
  	width: 200px;
  	height: 44px;
  	line-height: 44px;
  	color: #FFFFFF;
  	background-color: #4fa7ff;
  	display: inline-block;
  	margin-top: 60px;
    cursor: pointer;
  }
  .line {
  	height: 1px;
  	background-color: #eee;
  	margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/examsdetail.vue